<template>
  <section>
    <b-card>
      <!-- BUSCADOR + CANTIDAD + AGREGAR EN UNA FILA -->
      <b-row class="align-items-end">
        <b-col md="7">
          <b-form-group label="Imagen">
            <v-select
              v-model="seleccion"
              :options="opciones"
              :filterable="false"
              :loading="cargando"
              label="label"
              placeholder="Buscar imagen por nombre…"
              @search="onSearch"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Cantidad" class="mb-0">
            <b-form-input type="number" min="1" step="1" v-model.number="form.cantidad" />
          </b-form-group>
        </b-col>
        <b-col md="2" class="d-flex align-items-end">
          <b-button variant="primary" block :disabled="!seleccion || !form.cantidad || form.cantidad < 1" @click="agregar">
            + Agregar
          </b-button>
        </b-col>
      </b-row>

      <!-- LISTA / VACÍO -->
      <b-alert v-if="!items.length" variant="danger" show class="mb-0">
        No ha registrado ninguna imagen
      </b-alert>

      <b-table
        v-else
        :items="items"
        :fields="fields"
        small
        responsive
        class="mb-0"
      >
        <template #cell(acciones)="{ index }">
          <b-button size="sm" variant="danger" @click="$emit('eliminar', index)">
            <i class="fa fa-times"></i>
          </b-button>
        </template>
      </b-table>

    </b-card>
  </section>
</template>

<script>
import { BCard, BRow, BCol, BFormGroup, BFormInput, BAlert, BTable, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'PaqImagen',
  components: {
    BCard, BRow, BCol, BFormGroup, BFormInput, BAlert, BTable, BButton,
    vSelect,
  },
  props: {
    items: { type: Array, required: true },
    buscar: { type: Function, required: true },
  },
  data () {
    return {
      cargando: false,
      opciones: [],
      seleccion: null,
      form: {
        cantidad: 1,
      },
      fields: [
        { key: 'codigo', label: 'Código', thClass: 'text-center', tdClass: 'align-middle' },
        { key: 'descripcion', label: 'Descripción', thClass: 'text-center', tdClass: 'align-middle' },
        { key: 'cantidad', label: 'Cant.', thClass: 'text-center', tdClass: 'text-center align-middle', sortable: true },
        { key: 'acciones', label: 'Acciones', thClass: 'text-center', tdClass: 'text-right align-middle' },
      ],
    }
  },
  methods: {
    async onSearch (term) {
      if (!term || term.trim().length < 2) { this.opciones = []; return }
      this.cargando = true
      try {
        const rs = await this.buscar(term.trim())
        this.opciones = (rs || []).map(i => ({
          ...i,
          label: `(${i.codigo}) ${i.descripcion}`,
        }))
      } finally {
        this.cargando = false
      }
    },
    agregar () {
      if (!this.seleccion) return
      const payload = {
        id: this.seleccion.id,
        codigo: this.seleccion.codigo,
        descripcion: this.seleccion.descripcion,
        cantidad: this.form.cantidad || 1,
      }
      this.$emit('agregar', payload)
      this.form = { cantidad: 1 }
    },
  },
}
</script>

<style scoped>
/* estilos opcionales */
</style>
